import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api/axios.config';
import PhaseApi from '../../services/phase';
import SubjectApi from '../../services/subjectService';
import { notify } from '../utils/methods/notification';
// import { notify } from '../utils/methods/notification';

const initialState = {
    isLoading: false,
    historyLoading: false,
    allLocation: [],
    allLSMRejectionReason: [],
    activeV2VCycle: 0,
    V2VCycle: [],
    currentCycle: {},
    followCycle:{},
    veinToVein: [],
    allInitialSteps: [],
    formPresetData: [],
    allPatientData:{},
    allCoaForm:{}
};


// fetch the all primary diagnosis list 
export const fetchLocations = createAsyncThunk(
    'bmr/fetchLocations',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/location/active/status');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fetch the all lsm_rejection_reasons list 
export const fetchLSMRejectionReason = createAsyncThunk(
    'bmr/fetchLSMRejectionReason',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get('/lsm_rejection_reasons/active/status');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fetch phase list
export const fetchAllPhases = createAsyncThunk(
    'roles/fetchAllPhases',
    async (userId, { rejectWithValue }) => {
        try {
            const response = await PhaseApi.getPhaseListData('', 1, '', '', userId);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);

// fetch the all patient  list 
export const fetchAllPatient = createAsyncThunk(
    'bmr/fetchAllPatient',
    async (phase_id, { rejectWithValue }) => {
        try {
            const response = await SubjectApi.getSubjectList(phase_id, '', '');
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// fetch the vien to vien status  list 

export const fetchV2V = createAsyncThunk(
    'bmr/fetchV2V',
    async (args, { rejectWithValue }) => {
        try {
            const { portal_type, patient_id } = args
            const response = await api.get(`/v2v/${portal_type}/timeline-steps/${patient_id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);
// fetch the vien to vien status  list History 

export const fetchV2VHistory = createAsyncThunk(
    'bmr/fetchV2VHistory',
    async (args, { rejectWithValue }) => {
        try {
            const { portal_type, patient_id } = args
            const response = await api.get(`/v2v/${portal_type}/timeline-steps/history/${patient_id}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// @info marked as Received for portal 1
export const markedAsReceived = createAsyncThunk(
    'bmr/markedAsReceived',
    async (args, { rejectWithValue }) => {
        try {
            const { patient_id, feasibility_id } = args
            const response = await api.post(`/v2v/mark-as-received/${patient_id}/${feasibility_id}`);
            notify.success(response?.data?.message);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// @info Start Apheresis for portal 1
export const startApheresis = createAsyncThunk(
    'bmr/startApheresis',
    async (args, { rejectWithValue }) => {
        try {
            const { patient_id, feasibility_id } = args
            const response = await api.post(`/v2v/start-apheresis/${patient_id}/${feasibility_id}`);
            notify.success(response?.data?.message);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// @info Marked as dispatched for portal 1
export const markedAsDispatched = createAsyncThunk(
    'bmr/markedAsDispatched',
    async (args, { rejectWithValue }) => {
        try {
            const { patient_id, feasibility_id, data } = args
            const response = await api.post(`/vein-to-vein/mark-as-dispatched/${patient_id}/${feasibility_id}`, data);
            notify.success(response?.data?.message);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);



// @info get Esential patient for the portal 1
export const fetchSubjectPreset = createAsyncThunk(
    'bmr/fetchSubjectPreset',
    async (id, { rejectWithValue }) => {
        try {
            const response = await SubjectApi.presetSubjectData(id);

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);




const bmrCommonSlice = createSlice({
    name: 'bmrCommon',
    initialState,
    reducers: {
        changeFollowCycle(state, action){
            const { index, cycle } = action.payload;
            state.followCycle = cycle[index];
            state.allInitialSteps = cycle[index]?.data;
        },
        changeV2VCycle(state, action) {
            const { index, cycle } = action.payload;
            state.allInitialSteps = cycle[index]?.data;
            state.currentCycle = cycle[index];
            state.activeV2VCycle = index;
        },
        storePatientData(state,action){
           state.allPatientData =  action.payload;
        },
        setCoaFormData(state,action){
           state.allCoaForm =  action.payload;
        },
         clearCoaFormData(state){
           state.allCoaForm =  {};
        },
         clearCurrentCyclesData(state){
            state.allInitialSteps = [];
            state.currentCycle = {};
            state.activeV2VCycle = 0;
        }
    },
    extraReducers: (builder) => {
        /// handle fetch all primary diagnosis list
        builder
            .addCase(fetchLocations.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchLocations.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allLocation = action.payload.data
            })
            .addCase(fetchLocations.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(fetchLSMRejectionReason.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchLSMRejectionReason.fulfilled, (state, action) => {
                state.isLoading = false;
                state.allLSMRejectionReason = action.payload.data
            })
            .addCase(fetchLSMRejectionReason.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(fetchAllPhases.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllPhases.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchAllPhases.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(fetchAllPatient.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchAllPatient.fulfilled, (state) => {
                state.isLoading = false;
            })
            .addCase(fetchAllPatient.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(fetchV2V.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchV2V.fulfilled, (state, action) => {
                state.isLoading = false;
                const dataSteps = action.payload.data.reverse()
                state.allInitialSteps = dataSteps[state.activeV2VCycle || 0]?.data
                state.currentCycle = dataSteps[state.activeV2VCycle || 0]
                state.V2VCycle = dataSteps;
            })
            .addCase(fetchV2V.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(fetchV2VHistory.pending, (state) => {
                state.historyLoading = true;
            })
            .addCase(fetchV2VHistory.fulfilled, (state) => {
                state.historyLoading = false;
            })
            .addCase(fetchV2VHistory.rejected, (state) => {
                state.historyLoading = false;
            });

        builder
            .addCase(markedAsReceived.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(markedAsReceived.fulfilled, (state, action) => {
                state.isLoading = false;
                state.veinToVein = action.payload.data
            })
            .addCase(markedAsReceived.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(startApheresis.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(startApheresis.fulfilled, (state, action) => {
                state.isLoading = false;
                state.veinToVein = action.payload.data
            })
            .addCase(startApheresis.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(markedAsDispatched.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(markedAsDispatched.fulfilled, (state, action) => {
                state.isLoading = false;
                state.veinToVein = action.payload.data
            })
            .addCase(markedAsDispatched.rejected, (state) => {
                state.isLoading = false;
            });
        builder
            .addCase(fetchSubjectPreset.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchSubjectPreset.fulfilled, (state, action) => {
                state.isLoading = false;
                state.formPresetData = action.payload
            })
            .addCase(fetchSubjectPreset.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export const { changeV2VCycle,changeFollowCycle,storePatientData,clearCurrentCyclesData,clearCoaFormData,setCoaFormData } = bmrCommonSlice.actions;


export const selectLocationLoading = (state) => state.bmrCommon.isLoading;
export const selectHistoryLoading = (state) => state.bmrCommon.historyLoading;
export const selectAllInitialSteps = (state) => state.bmrCommon.allInitialSteps;

export const selectV2VCycle = (state) => state.bmrCommon.V2VCycle;
export const selectActiveV2VCycle = (state) => state.bmrCommon.activeV2VCycle;
export const selectCurrentCycle = (state) => state.bmrCommon.currentCycle;
export const selectPatientInfo = (state) => state.bmrCommon.allPatientData;
export const selectCoaInfo = (state) => state.bmrCommon.allCoaForm
//new cycle state
export const selectFollowCycle = (state) => state.bmrCommon.followCycle


export const selectAllLocation = (state) => state.bmrCommon.allLocation;
export const selectAllLSMRejectionReason = (state) => state.bmrCommon.allLSMRejectionReason;
export default bmrCommonSlice.reducer;
